<script setup lang="ts">
import { Activity, ColorSwitch, HintonPlot } from '@vicons/carbon';

/**
 * 编辑器底部状态栏属性。
 */
interface EditorFooterProps {
  /** 当前选中对象名称。 */
  selectedObjectName?: string;
  /** 几何内核是否初始化完成。 */
  engineReady?: boolean;
}

const props = withDefaults(defineProps<EditorFooterProps>(), {
  selectedObjectName: '',
  engineReady: false,
});
</script>

<template>
  <n-divider class="!m-0" />
  <div class="h-30px px-4 text-12px w-full flex justify-between items-center">
    <div class="flex items-center">
      <n-badge :type="props.engineReady ? 'success' : 'warning'" dot class="mr-3px" />
      <n-text depth="3">
        {{ props.engineReady ? '初始化完成' : '初始化...' }}
      </n-text>

      <n-divider vertical />

      <n-text depth="3">
        {{ props.selectedObjectName ? `选中: ${props.selectedObjectName}` : '未选中' }}
      </n-text>
    </div>
  </div>
</template>
